import React, {
 useCallback, useState, FormEvent, useEffect
} from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { MdInfo } from 'react-icons/md';
import ReactTooltip from 'react-tooltip';
import Input from '../../Input/Input';
import Button from '../../Button';
import { useRegister } from '../../../hooks/register';
import { cpfMask, cpfValidation } from '../../../utils/validations/cpf';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';
import { DescriptionContent, IconTooltip, SignupModalContainer, BackButton } from '../styles';

const CpfSignUp: React.FC = () => {
  const { handleData, handleStep, userData } = useRegister();
  const [cpf, setCpf] = useState(userData?.documentNumber ? cpfMask(userData?.documentNumber) : '');
  const [error, setError] = useState('');
  const [validCpf, setValidCpf] = useState(false);

  const validateCpf = async (cpfText: string) => {
    const formattedCpf = cpfMask(cpfText);
    const cpfTyped = cpfText.length >= 14;
    setError('');
    setValidCpf(false);

    try {
      await cpfValidation(formattedCpf);
      setValidCpf(true);
    } catch (err) {
      if (cpfTyped) {
        setError(err.message);
      }
    }
  };

  const handleInputChange = useCallback(async (cpfText) => {
    const formattedCpf = cpfMask(cpfText);
    setCpf(formattedCpf);
  }, []);

  const onSubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      setError('');
      handleData({ documentNumber: cpf.replace(/\D+/g, '') });
      handleStep('fillEmail');
    },
    [cpf],
  );

  useEffect(() => {
    validateCpf(cpf);
  }, [cpf]);

  return (
    <SignupModalContainer>
      <SignHeadText>
        <label>Por favor, nos informe seu CPF</label>
        <DescriptionContent>
          <p>Porque precisamos dessas informações?</p>
          <IconTooltip data-for="cpfTooltip" data-tip="1">
            <MdInfo size={20} />
          </IconTooltip>
          <ReactTooltip
            id="cpfTooltip"
            globalEventOff="click"
            effect="solid"
            delayHide={500}
            place={'bottom'}
            type={'light'}
          >
            Vamos utilizar esse dado para que você possa usufruir de toda rede Allya, já que alguns parceiros utilizam o
            CPF apenas para validação e liberação do benefício.
          </ReactTooltip>
        </DescriptionContent>
      </SignHeadText>
      <form onSubmit={onSubmit}>
        <Input
          autoFocus
          name="cpf"
          type="text"
          placeholder="CPF"
          width="full"
          value={cpf}
          onChangeValue={handleInputChange}
        />
        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>
        <Button title="Continuar" disabled={!validCpf} classType="big fat orange center topspace" type="submit" />
        <BackButton onClick={() => handleStep('fillName')} />
      </form>
    </SignupModalContainer>
  );
};

export default CpfSignUp;
